
// src/hooks/useSearchQuery.js

import { searchDomains, getDomainPrice } from '../api';
import { useMutation, useQuery } from '@tanstack/react-query';

// React Query hook to search for domains (manual trigger)

export const useSearchQuery = () => {
  return useMutation({
    mutationFn: ({ searchQuery, page = 1, limit = 10, category = null }) =>
      searchDomains(searchQuery, page, limit, category),
  });
};

// React Query hook to get domain price
export const useDomainPrice = (domain, options = {}) => {
  return useQuery({
    queryKey: ['domainPrice', domain],
    queryFn: () => getDomainPrice(domain),
    enabled: !!domain && options.enabled !== false, // Only run if domain exists and not explicitly disabled
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    ...options,
  });
};


